export const Disclosure = `
    <Disclosure items={[{ title: 'test', content: 'hello world' }]} defaultOpen />
`
